import React, { useState } from 'react';
import { NumberInput } from 'carbon-components-react';

const CustomNumericInput = props => {
  const [value, setValue] = useState(props.formData || 0);
  let label = props.schema.title;

  if (props.required) label += ' *';

  const onChange = event => {
    if (event.type !== 'click') {
      setValue(parseInt(event.target.value));
      props.onChange(parseInt(event.target.value));
    }
  };

  const onClick = event => {
    let auxVal = 0;
    if (value) {
      auxVal = value;
    }
    if (event.target.title === 'Increment number') {
      auxVal++;
    } else if (event.target.title === 'Decrement number') {
      auxVal--;
    }
    setValue(auxVal);
    props.onChange(auxVal);
  };

  return (
    <NumberInput
      id={props.idSchema.$id}
      invalid={false}
      invalidText='A valid value is required'
      label={label}
      value={value}
      onChange={onChange}
      onClick={onClick}
      disabled={props.schema.readOnly}
      style={{ background: 'white', width: '100%', minWidth: '200px' }}
    />
  );
};

export default CustomNumericInput;
